import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Channel = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Channel" {...props}>
    <path d="M2.24707 1.3418C2.58796 0.952268 3.16495 0.890297 3.57812 1.18359L3.6582 1.24707L11.376 8H12.624L20.3418 1.24707C20.7574 0.883778 21.3894 0.926346 21.7529 1.3418C22.1163 1.75742 22.0737 2.38934 21.6582 2.75293L15.6611 8H20C21.6568 8 22.9999 9.34319 23 11V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V11C1.00006 9.34319 2.34318 8 4 8H8.33887L2.3418 2.75293L2.26758 2.68164C1.92199 2.31115 1.90646 1.73142 2.24707 1.3418ZM4 10C3.44775 10 3.00006 10.4478 3 11V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V11C20.9999 10.4478 20.5523 10 20 10H4Z" fill="#000" />
  </StyledIcon>
));

Channel.displayName = 'Channel';

export { Channel };
